import { TeamMember } from "../../models/teamModel";
import { classNames, getGolfPlayerCategory } from "../../utils/appUtils";
import { Badge } from "../catalyst/badge";
import { Text } from "../catalyst/text";
import { UserView } from "../UserView";

export const MemberRow = ({
  member,
  className,
}: {
  member: TeamMember;
  className?: string;
}) => {
  return (
    <>
      <div
        className={classNames(
          "flex flex-row ml-2 gap-4 my-1",
          className ? className : "",
          "hidden sm:flex"
        )}
      >
        <UserView member={member} />
        <div>
          {member.isOwner && (
            <Badge
              color="blue"
              className="text-xs font-semibold mr-2 px-2.5 py-0.5"
            >
              Owner
            </Badge>
          )}
          {member.isCaptain && (
            <Badge
              color="green"
              className="text-xs font-semibold mr-2 px-2.5 py-0.5"
            >
              Captain
            </Badge>
          )}

          {member.isCoreMember && (
            <Badge
              color="red"
              className="text-xs font-semibold mr-2 px-2.5 py-0.5"
            >
              Core
            </Badge>
          )}
          {member.isPlayer && (
            <Badge
              color="yellow"
              className="text-xs font-semibold mr-2 px-2.5 py-0.5"
            >
              Player
            </Badge>
          )}
        </div>
        {member.isPlayer && (
          <>
            <div className="w-2 text-center">
              <Text className="text-md font-semibold">
                {member.playerHandicap}
              </Text>
            </div>
            <div className="w-3 text-center mx-2">
              <Text className="text-md font-semibold">
                {getGolfPlayerCategory(member.ageCategory, member.gender)}
              </Text>
            </div>
          </>
        )}
      </div>
      <div
        className={classNames(
          "ml-2 gap-4 my-1",
          className ? className : "",
          "flex sm:hidden"
        )}
      >
        <div className="w-full">
          <UserView member={member} />
          <div className="flex flex-wrap flex-row justify-between gap-4 w-full">
            <div>
              {member.isOwner && (
                <Badge
                  color="blue"
                  className="text-xs font-semibold mr-2 px-2.5 py-0.5"
                >
                  Owner
                </Badge>
              )}
              {member.isCaptain && (
                <Badge
                  color="green"
                  className="text-xs font-semibold mr-2 px-2.5 py-0.5"
                >
                  Captain
                </Badge>
              )}

              {member.isCoreMember && (
                <Badge
                  color="red"
                  className="text-xs font-semibold mr-2 px-2.5 py-0.5"
                >
                  Core
                </Badge>
              )}
              {member.isPlayer && (
                <Badge
                  color="yellow"
                  className="text-xs font-semibold mr-2 px-2.5 py-0.5"
                >
                  Player
                </Badge>
              )}
            </div>
            {member.isPlayer && (
              <div className="flex flex-row items-center gap-5">
                <div className="w-3 text-center">
                  <Text className="text-md font-semibold">
                    {member.playerHandicap}
                  </Text>
                </div>
                <div className="w-3 text-center mx-2">
                  <Text className="text-md font-semibold">
                    {getGolfPlayerCategory(member.ageCategory, member.gender)}
                  </Text>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
